import React from 'react'
import { useDetectionExplorerStore, ViewMode } from '../DetectionExplorerStore'
import { ResultFiltersUI } from './ResultFiltersUI'

export const ResultFiltersContainer = () => {
    const clientFilters = useDetectionExplorerStore((s) => s.clientFilters)
    const setClientFilter = useDetectionExplorerStore((s) => s.setClientFilter)
    const viewMode = useDetectionExplorerStore((s) => s.viewMode)
    const cardSize = useDetectionExplorerStore((s) => s.cardSize)
    const setCardSize = useDetectionExplorerStore((s) => s.setCardSize)

    return (
        <ResultFiltersUI
            filters={clientFilters}
            showLpFilters={viewMode === ViewMode.GroupByLPView}
            onChange={setClientFilter}
            // The table view has no cards, so the size scale only makes sense in gallery / group-by-LP.
            showCardSize={viewMode !== ViewMode.ListView}
            cardSize={cardSize}
            onCardSizeChange={setCardSize}
        />
    )
}
